export const constant = {
  emailArticleButtonText: 'Email article',
  trackingMessage: 'emailArticle',
  link: 'https://www.decentraland.org/docs/',
};
